<template>
  <div class="shop-content">
    <ph-header>
      <van-icon name="arrow-left" size="20px" slot="left" @click="$router.back(-1)" />
    </ph-header>
    <div class="order-detail-content">
      <!-- 订单状态 -->
      <section class="order-status-wrapper">
        <div class="order-status" :class="{'order-status_fail': order.soStatusEN==101 || order.soStatusEN==20 || order.soStatusEN==6 || order.soStatusEN==8 || order.soStatusEN==14 || order.soStatusEN==19 }">
            <div class="order-status-content">
              <span class="status-info-text ">{{order.soStatusCN}}</span>
              <span class="status-info-text_info fz18" v-if="order.countDownSecond>0"><van-count-down :time="order.countDownSecond*1000" /> 后自动关闭订单</span>
            </div>
            <!-- 1待付款;
            2待卖家发货；
            3卖家已发货；
            4待胖虎鉴定中心鉴定；
            5鉴定通过待发货 、待胖虎发货；
            6鉴定未通过待退款；
            7胖虎已发货；
            8鉴定未通过已退款；
            9已收货 ；
            14已退款
            16已付款待确认；
            17调货中；
            18鉴定未通过已退款；
            19退款中；
            20拒绝退款;
            100交易成功；
            101交易关闭； -->

            <!-- status-close 交易关闭 -->
            <!-- status-pass  待鉴定-->
            <!-- status-payment 已付款 -->
            <!-- status-recived 已收货 -->
            <!-- status-refund 拒绝退款 -->
            <!-- status-shipped 待发货 -->
            <!-- status-unpass 鉴定未通过/ 已退款 -->
            <div class="status-info-icon">
              <img src="@/assets/img/icon_st01.png" alt="" v-if="order.soStatusEN==1 || order.soStatusEN==16">
              <img src="@/assets/img/icon_st02.png" alt="" v-if="order.soStatusEN==2 || order.soStatusEN==3 || order.soStatusEN==5">
              <img src="@/assets/img/icon_st03.png" alt="" v-if="order.soStatusEN==7 || order.soStatusEN==9 || order.soStatusEN==17 || order.soStatusEN==100">
              <img src="@/assets/img/icon_st04.png" alt="" v-if="order.soStatusEN==101">
              <img src="@/assets/img/icon_st05.png" alt="" v-if="order.soStatusEN==14 || order.soStatusEN==19 || order.soStatusEN==20">
              <img src="@/assets/img/icon_st06.png" alt="" v-if="order.soStatusEN==4">
              <img src="@/assets/img/icon_st07.png" alt="" v-if="order.soStatusEN==6">
              <!-- <svg-icon v-if="order.soStatusEN == 101" iconClass="status-close" class="ph-icon"></svg-icon>
              <svg-icon v-if="order.soStatusEN == 4" iconClass="status-pass" class="ph-icon"></svg-icon>
              <svg-icon iconClass="status-payment" class="ph-icon"></svg-icon>
              <svg-icon v-if="order.soStatusEN == 9" iconClass="status-recived" class="ph-icon"></svg-icon>
              <svg-icon v-if="order.soStatusEN == 20" iconClass="status-refund" class="ph-icon"></svg-icon>
              <svg-icon v-if="order.soStatusEN == 2" iconClass="status-shipped" class="ph-icon"></svg-icon>
              <svg-icon v-if="order.soStatusEN == 6 || order.soStatusEN == 14" iconClass="status-unpass" class="ph-icon"></svg-icon>
              <img :src="'@/assets/img/order-status_' + order.soStatusEN + '.png'" alt=""> -->
            </div>
        </div>

      </section>
      <!-- 收货地址信息 -->
      <section class="address fz28 mb24 ">
        <div class="address-title">
          <span class="fz28 fw">收货信息</span>
          <span class="fz24"></span>{{order.expressType=='1'?'快递到家':'到店自提'}}</span>
        </div>
        <div class="address-wrapper">
          <div class="add-info fz24">
            <span>{{order.consignee}} {{order.consigneePhone}}</span>
            <span >{{order.consigneeAddress}}</span>
          </div>
        </div>

        <div class="address-delivery-info" v-if="order.logisticsInfo" @click="logistics">
          <div class="delivery-info">
            <div class="title">
              <span class="lable">物流跟踪</span>
              <span class="c999 fz28">{{order.logisticsInfo.datetime}}</span>
            </div>
            <div class="content">
              <span class="fw">{{order.logisticsInfo.remark}}</span>
            </div>
          </div>
          <van-icon name="arrow" size="14px" slot="left" style="position: absolute;right: 0.32rem;" />
        </div>
        <div class="address-balance-line"></div>
      </section>
      <!-- 商品信息 -->
      <section class="order-info-box">
        <div class="order-info-title">
          <div class="fz28 c999">共{{goodsNum}}件商品</div>
          <div class="fz24">
            <van-icon name="comment-o" size="20px" />
            <span class="text" @click="custService=true">联系客服</span>
          </div>
        </div>
        <div class="order-item" v-for="(item, index) in order.goodsList" :key="index"  @click="goInfo(item.goodId)">
          <div class="img-box">
            <img :src="item.goodLogo" alt="" srcset="">
          </div>
          <div class="order-content fz28">
            <div class="order-title">{{item.goodName}}</div>
            <!-- <div class="order-desc">{{order.categoryname}}</div> -->
            <div class="order__bottom">
              <div data-v-47aa186e="" class="order__price">¥ {{item.price}}</div>
            </div>
          </div>
        </div>
      </section>
      <section class='discount-box mb24'>
        <div class="item-cell">
          <span>商品金额</span>
          <span class='fw'>¥{{order.goodsAmount}}</span>
        </div>
        <div class="item-cell" v-if="order.couponAmount">
          <span>优惠券</span>
          <span class='fw'>-¥{{order.couponAmount || 0}}</span>
        </div>
        <div class="item-cell" v-if="order.rewardAmount">
          <span>奖励金抵扣</span>
          <span class='fw'>-¥{{order.rewardAmount || 0}}</span>
        </div>
        <div class="item-cell fz28 total">
          <span class='c28' v-if="order.soStatusEN==1">应付金额</span>
          <span class='c28' v-else>订单金额</span>
          <span class='cred fw'>¥{{order.orderAmount}}</span>
        </div>
      </section>

      <section class="order-box">
        <van-cell-group>
          <van-cell>
            <template slot="title">
              <span class="custom-title">订单编号</span>
              <span class="custom-text">{{order.soNumber}}</span>
            </template>
            <template slot="right-icon">
              <van-button round type="default" size='mini' id='orderNumber' @click="clipboard('#orderNumber',order.soNumber)">复制</van-button>
            </template>
          </van-cell>
          <van-cell>
            <template slot="title">
              <span class="custom-title">下单时间</span>
              <span class="custom-text">{{order.createTime}}</span>
            </template>
          </van-cell>
          <van-cell v-if="order.paymentCode != ''">
            <template slot="title">
              <span class="custom-title">支付方式</span>
              <span class="custom-text">{{order.paymentName}}</span>
            </template>
          </van-cell>
        </van-cell-group>
      </section>
        <!-- 推荐列表 -->
      <div class="goods-recommend-list" v-if="recomendList.length > 0 ">
        <div class="goods-item-title fw">
            <span class="fz36">猜你喜欢</span>
            <span class="fz20">YOU MAY ALSO LIKE</span>
        </div>
        <div class="goods-recommend-content">
            <good-grid :list="recomendList"></good-grid>
            <van-divider :style="{ color: '#ccc', borderColor: '#ccc', padding: '0 90px' }">已经到底了</van-divider>
        </div>
      </div>

      <div class="footer-btn" v-if="order.soStatusEN == 1">
         <van-button plain hairline round type="ph-default" size='small' @click="cancelOrder" >取消订单</van-button>
         <van-button round type="ponhu" size='small'  @click="goPay(order.goodsList, order.soNumber)">立即支付</van-button>
      </div>
      <div class="footer-btn" v-if="order.soStatusEN == 16">
         <van-button round type="ponhu" size='small'  @click="goCertificate">更新凭证</van-button>
      </div>
      <div class="footer-btn" v-if="order.soStatusEN == 2">
         <van-button plain hairline round type="ph-default" size='small'  @click="refundOrder">申请退款</van-button>
      </div>
      <div class="footer-btn" v-if="order.soStatusEN==3 || order.soStatusEN==4 || order.soStatusEN==5 || order.soStatusEN==17">
         <van-button round type="ponhu" size='small'  @click="logistics">查看物流</van-button>
      </div>
      <div class="footer-btn" v-if="order.soStatusEN == 7">
         <van-button plain hairline round type="ph-default" size='small' @click="logistics" >查看物流</van-button>
         <van-button round type="ponhu" size='small'  @click="confirmOrder">确认收货</van-button>
      </div>
      <div class="footer-btn" v-if="order.soStatusEN==21">
         <van-button round type="ponhu" size='small'  @click="confirmOrder">确认收货</van-button>
      </div>
      <div class="footer-btn" v-if="order.soStatusEN==8 || order.soStatusEN==18 || order.soStatusEN==14">
         <van-button round type="ponhu" size='small'  @click="refund">查看退款</van-button>
      </div>
      <div class="footer-btn" v-if="order.soStatusEN==20">
         <van-button round type="ponhu" size='small'  @click="checkReason">查看原因</van-button>
      </div>
      <div class="footer-btn" v-if="order.soStatusEN==9 || order.soStatusEN==100 || order.soStatusEN==101">
         <van-button plain hairline round type="ph-default" size='small' @click="deleteOrder" >删除订单</van-button>
      </div>
    </div>
    <van-action-sheet v-model="custService">
      <service-sheet @close="custService=false"></service-sheet>
    </van-action-sheet>
  </div>
</template>

<script>
import ClipboardJS from 'clipboard'
import PhHeader from '@/components/common/Header'
import GoodGrid from '@/components/business/GoodGrid'
import { getOrderDetail, getWxUrl, orderCancel, orderDelete, orderConfirm, orderRefusereson } from '@/api/order'
import { getGuessLikeList } from '@/api/good'
import { CountDown } from 'vant'
import ServiceSheet from '@/components/business/ServiceSheet' 
import { getSystem, openApp, BrowserInfo } from '@/utils'
export default {
  name: 'shopOrderDetail',
  components: {
    PhHeader,
    GoodGrid,
    ServiceSheet,
    [CountDown.name]: CountDown
  },
  data () {
    return {
      paytype: '1',
      showPay: false,
      order_id: '',
      tips: false,
      custService: false,
      time: '',
      totalPrice: 0, // 必须数字类型
      submit_loading: false,
      order: {
        status: 3,
        ordertype: 1
      },
      recomendList: [],
      goodsNum: 0,
      custService: false,
    }
  },
  computed: {
    token () {
      return this.$store.getters.token
    }
  },

  mounted () {
    this.getOrderInfoData()
    this.getGuessLikeListData()
  },
  methods: {
    getOrderInfoData () {
      getOrderDetail({ userToken: this.token, soNumber: this.$route.params.oid }).then(res => {
        this.order = res
        this.order_id = res.soNumber;
        this.goodsNum = res.goodsList.length;
      }).catch(err => {
        this.$toast(err)
      })
    },
    // 推荐列表
    getGuessLikeListData () {
      getGuessLikeList({ userToken: this.token }).then(res => {
        this.recomendList = res
      }).catch(err => {
        this.$toast(err)
      })
    },
    logistics (oid) {
      this.$router.push({ name: 'logistics', query: { oid: oid } })
    },
    clipboard (item, value) {
      let that = this
      var clipboard = new ClipboardJS(item, {
        text: function (trigger) {
          return value
        }
      })
      clipboard.on('success', function (e) {
        that.$toast('已经复制到粘贴板！')
        e.clearSelection()
      })

      clipboard.on('error', function (e) {
        that.$toast('该设备不支持自动复制')
      })
      this.custService = false
    },
    // 支付
    goPay (goods, oid) {
      // 清理结算缓存
      this.$store.dispatch('BalanceOut')
      if (goods.length === 0) return false
      let gid = goods[0].gid
      if (this.token) {
        let url = '/pay/balance/' + gid + '?oid=' + oid
        if (BrowserInfo().isWeixin) {
          getWxUrl({ url: url, label: 1 }).then(res => {
            location.href = res
          })
        } else {
          this.$router.push({ path: url })
        }
        // this.$router.push({ path: '/pay/balance/' + gid + "?oid=" + oid })
      } else {
        this.$router.push({ path: '/login?return_url=' + window.location.href })
      }
    },
    onSubmit () {
      this.showPay = true
    },
    goInfo (id) {
      this.$router.push({ name: 'shopGoodsDetail', params: { gid: id } })
    },
    // 微信复制
    onSelect (item) {
      this.custService = false
    },
    logistics() {
      this.$router.push({ name: 'logistics', query: { oid: this.order_id } })
    },
    kefu () {
      this.custService = true
    },
    cancelOrder() {
      orderCancel({ soNumber: this.order_id, userToken: this.token }).then(res => {
        this.$toast('订单已取消')
        this.$router.back(-1)
      }).catch(error => {
        this.$toast(err)
      })
    },
    // 物流
    logistics () {
      this.$router.push({ name: 'logistics', query: { oid: this.order_id } })
    },
    // 更新凭证
    goCertificate() {
      this.$router.push({ name: 'Epay', params: { oid: this.order_id } })
    },
    // 申请退款
    refundOrder() {
      this.$dialog.confirm({
        title: '提示',
        message: '下载胖虎奢侈品APP申请退款',
        confirmButtonText: '去下载'
      }).then(() => {
        openApp('ponhu://')
      }).catch(() => {
      })
    },
    // 退款
    refund() {
      this.$dialog.confirm({
        title: '提示',
        message: '下载胖虎奢侈品APP查看退款',
        confirmButtonText: '去下载'
      }).then(() => {
        openApp('ponhu://')
      }).catch(() => {
      })
    },
    // 查看原因
    checkReason() {
      orderRefusereson({ soNumber: this.order_id, userToken: this.token }).then(res => {
        this.$dialog.alert({
          message: res,
          confirmButtonText: '知道了'
        })
      }).catch(err => {
        this.$toast(err)
      })
    },
    // 确认收货
    confirmOrder() {
      this.$dialog.confirm({
        title: "提示",
        message: "是否确认收货？",
      }).then(() => {
        orderConfirm({ soNumber: this.order_id, userToken: this.token }).then(res => {
          this.$toast('确认收货成功')
          location.reload();
        }).catch(err => {
          this.$toast(err)
        })
      }).catch(() => {
      })
    },
    // 删除订单
    deleteOrder() {
      this.$dialog.confirm({
        title: "提示",
        message: "是否确认删除订单？",
      }).then(() => {
        orderDelete({ soNumber: this.order_id, userToken: this.token }).then(res => {
          this.$toast('订单已删除')
          this.$router.back(-1);
        }).catch(err => {
          this.$toast(err)
        })
      }).catch(() => {
      })
      
    },
  }
}
</script>

<style lang='less' scoped>

.van-count-down {
  color: #DA3232;
  font-weight: 800;
}
.action-btn {
  width: 100%;
  height: 100%;
  border: 0;
  background-color: transparent;
}
  .order-status {
    position: relative;
    width: 100%;
    height: 240px;
    background: linear-gradient(270deg, rgba(255, 86, 67, 1) 0%, rgba(255, 218, 112, 1) 100%);
    overflow: hidden;
    &::after {
      position: absolute;
      content: '';
      right: -100px;
      bottom: 0;
      width: 11.667rem;

      height: 2.467rem;
      background: linear-gradient(165deg, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 100%);
    }
    .order-status-content {
      position: absolute;
      left: 98px;
      top: 80px;
      display: flex;
      flex-direction: column;
      font-size: 32px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      .status-info-text {
        // margin-left: 15px;
        font-size: 32px;
        font-weight: bold;
        color: #fff;
      }
      .status-info-text_info {
        color: #fff;
      }
    }
    .status-info-icon{
      position: absolute;
      // width: 120px;
      // height: 120px;
      // background: #fff;
      left: 450px;
      top: 60px;
      img {
        width: 180px;
      }
    }
  }
  .order-status_fail{
    background: linear-gradient(270deg, #818181 0%, #C8C8C8 100%);
  }
  .address{
    background: #fff;
    &-title{
      display: flex;
      padding: 24px 24px 0;
      justify-content: space-between;
      span:last-child{color: #FE8613}
    }
    &-wrapper{
      display: flex;
      padding: 24px;
      // background:url('../../assets/img/balance-line.png') no-repeat left bottom;
      // background-size: 100%;
      .add-info{
        width: 80%;
      }
    }
    &-delivery-info{
      padding:  24px 30px;
      display: flex;align-items: center;
      position: relative;
      .delivery-info{
        .title{
          margin-bottom: 15px;
          .lable{
            font-size: 20px;
            padding: 2px 10px;
            border-radius:4px;
            color: #FFD133;
            background: #282828;
            margin-right: 20px;
          }
        }
      }
      &:after{
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 24px;
        top: 0;
        left: 24px;
        z-index: 100;
        border-bottom: 1px solid #ebedf0;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
      }
    }
    &-balance-line{
      background:url('../../assets/img/balance-line.png') no-repeat left bottom;
      background-size: 100%;
      height: 6px;
    }

    .username{
      flex-basis: 200px;
    }
    .add-info{
      display: flex;
      color: #282828;
      flex-direction: column;
    }
    .van-icon{
      align-self: center;
    }
  }
  .order-info-box {
    .order-info-title{
      background: #fff;
      display: flex;
      padding: 24px;
      justify-content: space-between;
      :last-child{
        display: flex;
        align-items: center;
        .text{margin-left:10px}
      }
    }
    .order-item {
      background: #fff;
      height: 208px;
      position: relative;
      color: #333;
      padding: 32px 24px;
      box-sizing: border-box;
      display: flex;
      .img-box {
        width: 144px;

        /* height: 144px; */
        img {
          display: block;
          width: 144px;
          height: 144px;
        }
      }

      .order-content {
        position: relative;
        display: flex;
        flex: 1;
        height: 90px;
        flex-direction: column;
        min-width: 0;
        flex: auto;
        margin-left: 20px;
        font-family: PingFangSC-Regular;

        .order__bottom {
          margin-top: 20px;

          .order__price {
            font-size: 32px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            color: #DA3232;
          }
        }

        .order-desc {
          margin-top: 10px;
        }
      }
    }
  }
  .goods-recommend-list{
      margin: 0 auto;
      .goods-item-title{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin: 24px 0;
      }
      .goods-recommend-content{
        padding: 0 24px;
      }
    }
  .order-box .custom-text {
    margin-left: 50px;
    font-size: 28px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #999;
  }

  .discount-box {
    padding: 31px 24px;
    background: #fff;
    font-size: 24px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #999999;

    .item-cell {
      display: flex;
      justify-content: space-between;

      &:not(:last-child) {
        margin-bottom: 20px
      }
    }
  }

  .actions-pay {
    .price {
      height: 60px;
      font-size: 60px;
      font-weight: 500;
      color: #282828;
      line-height: 60px;
      text-align: center;
      padding: 24px 0;
    }

    .btn {
      margin-top: 100px;
      padding: 0;
      width: 100%;
      height: 100px;
      background: #FFD133;
      font-size: 32px;
      font-weight: 500;
      color: #282828;
      border: 1px solid transparent;
      outline: none;
    }
  }

  .footer-btn {
    position: fixed;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    text-align: right;
    background-color: #fff;
    height: 100px;
    padding: 0 24px;
    .van-button{margin-left: 10px;padding: 0 20px;}
    // .btn {
    //   width: 140px;
    //   border-radius: 28px;
    //   font-size: 24px;
    //   color: #282828;
    //   font-weight: 500;
    //   text-align: center;
    //   vertical-align: super;
    //   padding: 16px 22px;
    // }

    // .ycolor {
    //   background-color: #FFD133;
    // }

    // .dcolor {
    //   border: 1px solid rgba(40, 40, 40, 1);
    // }
  }
</style>
